export default function getDomainName() {
  //各种环境域名
  let box = {};
  const {protocol,hostname} = window.location;
  // 线上地址
  let base = protocol + "//" + hostname
  if (process.env.NODE_ENV==='development') {  //开发环境
    box.baseUrl = '/cardShop';
    box.userUrl = '/user';
    box.walletUrl = "/wallet";
    box.shareUrl = "/share";
    box.cpUrl = "/cpa";
    box.url = "";
  } else {
    // 判断测试环境
    if (hostname.indexOf('test')>-1){
      base = 'http://testchaowanuser.abcs8.com';
    }
    box.baseUrl = base + '/cardShop';
    box.userUrl = base + '/user';
    box.walletUrl = base + '/wallet';
    box.shareUrl = base + '/share';
    box.cpUrl = base + "/cpa";
    box.url = base;
  }
  return box;
}




// WEBPACK FOOTER //
// ./src/api/conf.js